













































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import api from '@/infrastructure/api/movement/movementApi';
import {移動入力在庫場所型, 移動入力在庫場所結果型, 移動入力型, 移動登録型} from '@/type/movement/records/register/部署間移動入力';
import moment from 'moment';
import ProductSearchModal from '@/views/movement/ProductSearchModal.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import {loginModule} from '@/store/authentication/login';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import AmountField from '@/components/atom/input/AmountField.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import { progress } from '@/script/progress';
import DepartmentSelector from '@/components/department/DepartmentSelector.vue';
import 部署間移動入力チェッカー from '@/type/movement/records/register/部署間移動入力チェッカー';
import HandyMovementImport from '@/views/movement/HandyMovementImport.vue';

@Component({
  components: {
    Datepicker,
    ProductSearchModal,
    HandyMovementImport,
    ButtonPanel,
    IconButton,
    NormalButton,
    AmountField,
    ConfirmDialog,
    AlertDialog,
    DepartmentSelector,
  },
  filters: {
    日付フォーマット(date: Date): string | null {
      if (date === null) {
        return '';
      }
      return moment(date).format('YYYY/MM/DD');
    },
  },
})
export default class RegisterMovement extends Vue {
  // data
  アラートメッセージ: string | string[] = [];

  在庫場所一覧: 移動入力在庫場所型[] = [];
  移動元在庫部署コード: string | null = null;
  移動元選択済みフラグ: boolean = false;

  移動入力一覧: 移動入力型[] = [];

  選択移動: 移動入力型 | null = null;

  移動先在庫場所一覧: 移動入力在庫場所型[] = [];
  移動先在庫部署コード: string | null = null;
  移動年月日: Date = moment().toDate();

  削除対象インデックス: number | null = null;

  // computed
  get バラ管理である(): boolean {
    return loginModule.バラ管理である;
  }

  get 代行ログインである(): boolean {
    return loginModule.マスターである;
  }

  get 有効期限管理をする(): boolean {
    return loginModule.有効期限管理をする;
  }

  get 在庫場所未決定(): boolean {
    return !this.移動元選択済みフラグ;
  }

  get 在庫場所選択ができる(): boolean {
    if (this.移動元在庫部署コード === null) return false;
    return this.在庫場所未決定;
  }

  get HT移動一括取込する(): boolean {
    return loginModule.HT移動一括取込する;
  }

  // methods
  在庫場所初期値(): void {
    this.移動元在庫部署コード = loginModule.部署コードを取得する;
    if (!loginModule.管理者である) {
      this.在庫場所選択();
    }
  }

  async 在庫場所一覧取得(): Promise<void> {
    // FIXME 権限によって制御が必要？
    await api.移動入力在庫場所一覧を取得する()
            .then((response: 移動入力在庫場所結果型) => {
              this.在庫場所一覧 = response.移動在庫場所結果一覧;
            })
            .catch((error: any) => {
              this.在庫場所一覧 = [];
              this.アラートメッセージ = error.data.message;
              this.ダイアログを開く('アラート');
            });
  }

  削除ダイアログを開く(index: number): void {
    this.削除対象インデックス = index;
    this.ダイアログを開く('削除ダイアログ');
  }

  削除する(): void {
    if (this.削除対象インデックス !== null) {
      this.移動入力一覧.splice(this.削除対象インデックス, 1);
    }
    this.ダイアログを閉じる('削除ダイアログ');
  }

  在庫場所選択(): void {
    this.移動元選択済みフラグ = true;
    this.移動先在庫場所一覧 = [];
    for (const 在庫場所 of this.在庫場所一覧) {
      if (在庫場所.部署コード !== this.移動元在庫部署コード) {
        this.移動先在庫場所一覧.push(在庫場所);
      }
    }
    if (this.移動先在庫場所一覧.length > 0) {
      this.移動先在庫部署コード = this.移動先在庫場所一覧[0].部署コード;
    }
  }

  クリアする(): void {
    this.アラートメッセージ = [];

    this.移動入力一覧 = [];

    this.選択移動 = null;

    this.移動元選択済みフラグ = false;
    this.移動元在庫部署コード = '';

    this.移動年月日 = moment().toDate();
    this.移動先在庫部署コード = null;

    this.削除対象インデックス = null;

    this.在庫場所初期値();

    this.ダイアログを閉じる('クリアダイアログ');
  }

  async 確定するハンドラ(): Promise<void> {
    if (this.移動入力一覧.length === 0) {
      this.showAlert('部署間移動の確定対象が存在しません');
      return;
    }

    const checker = new 部署間移動入力チェッカー(this.移動入力一覧, this.バラ管理である);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    await progress(this.移動入力確定);
  }

  async 移動入力確定(): Promise<void> {
    const 移動登録一覧 = new Array<移動登録型>();
    for (const 移動入力 of this.移動入力一覧) {
      移動登録一覧.push({
        商品コード: 移動入力.商品コード,
        移動年月日: 移動入力.移動年月日,
        在庫部署コード: 移動入力.在庫部署コード,
        移動先部署コード: 移動入力.移動先部署コード,
        箱数: 移動入力.箱数,
        バラ数: 移動入力.バラ数,
        在庫区分: 移動入力.在庫区分,
        有効期限: 移動入力.有効期限,
      });
    }
    await api.移動を登録する(移動登録一覧)
      .then(() => {
        this.クリアする();
      })
      .catch((error: any) => {
        if (error.data.errors) {
          this.アラートメッセージ = error.data.errors;
        }
        if (error.data.message && !error.data.errors) {
          this.アラートメッセージ = [error.data.message];
        }
        this.ダイアログを開く('部署間移動入力アラート');
      });
  }

  商品検索ダイアログを開く(): void {
    this.ダイアログを開く('部署間移動商品追加画面');
  }

  confirmProductSearch(移動入力一覧: 移動入力型[]) {
    for (const 移動入力 of 移動入力一覧) {
      移動入力.移動年月日 = this.移動年月日;
      移動入力.移動先部署コード = this.移動先在庫部署コード;
      this.移動入力一覧.push(移動入力);
    }
  }

  HTデータ取込ダイアログを開く(): void {
    this.ダイアログを開く('部署間移動HTデータ取込画面');
  }

  確定ボタンが無効(): boolean {
    return this.在庫場所未決定;
  }

  ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  showAlert(message: string | string[]): void {
    this.アラートメッセージ = message;
    this.$modal.show('部署間移動入力アラート');
  }

  // lifecycle hooks
  async mounted(): Promise<void> {
    this.移動入力一覧 = [];
    await this.在庫場所一覧取得();
    this.在庫場所初期値();
  }

  private 数値入力エラー判定(行番号: number, 項目名: string): boolean {
    const checker = new 部署間移動入力チェッカー(this.移動入力一覧, this.バラ管理である);
    return checker.hasError(項目名, 行番号);
  }

  private 移動後在庫数チェック(行番号: number): void {
    if (this.バラ管理である) {
      return this.バラ管理の移動後在庫数計算処理(行番号);
    } else {
      return this.箱管理の移動後在庫数計算処理(行番号);
    }
  }

  private 箱管理の移動後在庫数計算処理(行番号: number): void {
    this.移動入力一覧[行番号].総移動数 = this.移動入力一覧[行番号].箱数;
    this.移動入力一覧[行番号].移動後在庫数 = this.移動後の在庫数を計算する(行番号);
  }

  private バラ管理の移動後在庫数計算処理(行番号: number): void {
    this.移動入力一覧[行番号].箱数バラ換算 = this.箱数をバラ数に換算する(行番号);
    this.移動入力一覧[行番号].総移動数 = this.移動するバラ数を合計する(行番号);
    this.移動入力一覧[行番号].移動後在庫数 = this.移動後の在庫数を計算する(行番号);
  }

  private 箱数をバラ数に換算する(行番号: number): any {
    if (this.移動入力一覧[行番号].包装単位数 === null || this.移動入力一覧[行番号].包装単位数 === 0) {
      return 0;
    }
    if (this.移動入力一覧[行番号].バラ単位区分 === '包装単位')　{
      return this.移動入力一覧[行番号].箱数 * this.移動入力一覧[行番号].入数;
    } else {
      return this.移動入力一覧[行番号].箱数 * (this.移動入力一覧[行番号].入数　/ this.移動入力一覧[行番号].包装単位数);
    }
  }

  private 移動するバラ数を合計する(行番号: number): any {
    return this.移動入力一覧[行番号].箱数バラ換算 + this.移動入力一覧[行番号].バラ数;
  }

  private 移動後の在庫数を計算する(行番号: number): any {
    return Math.round((this.移動入力一覧[行番号].現在庫数 - this.移動入力一覧[行番号].総移動数) * 1000) / 1000;
  }
}
